import { Component } from 'preact';
import ReactTable from 'react-table';
import { TableItemNumber, TableItemTime } from './table';
import { DownloadButton } from './download-button';
import 'react-table/react-table.css';
import '../styles/table.css';

export class StatsTable extends Component {
	state = {
		maxHeight: 0
	}

	tableRef = null

	columns = [
		{
			Header: 'Rule index',
			accessor: 'ruleIndex',
			Cell: row => (<TableItemNumber value={row.value} numberFormat={this.props.numberFormat} />)
		},
		{
			Header: 'Filename',
			accessor: 'filename',
			Cell: row => <span class={row.value || 'bold'} title={row.value}>{row.value || '-'}</span>
		},
		{
			Header: 'Line number',
			accessor: 'lineNumber',
			Cell: row => (<TableItemNumber value={row.value} numberFormat={this.props.numberFormat} />)
		},
		{
			Header: 'Relationship',
			accessor: 'relationship',
			width: 250,
			Cell: row => <span title={row.value}>{row.value}</span>
		},
		{
			Header: 'Calls',
			accessor: 'calls',
			Cell: row => (<TableItemNumber value={row.value} numberFormat={this.props.numberFormat} />)
		},
		{
			Header: 'Total time',
			accessor: 'totalTime',
			Cell: row => (<TableItemTime value={row.value} numberFormat={this.props.numberFormat} />)
		},
		{
			Header: 'Average time',
			accessor: 'averageTime',
			Cell: row => (<TableItemTime value={row.value} numberFormat={this.props.numberFormat} />)
		}
	]

	updateMaxHeight = () => {
		const height = this.tableRef.clientHeight;
		if (height > this.state.maxHeight) {
			this.setState({
				maxHeight: height
			});
		}
	}

	onDownloadClick = () => {
		const headers = this.columns.map(c => c.Header).join(',')
		const accessors = this.columns.map(c => c.accessor)

		const csv = this.props.stats
			.map(stat =>
				accessors.map(accessor => stat[accessor] || '').join(',')
			)
			.join('\n')

		const csvBlob = new Blob([headers + '\n' + csv]);

		const downloadUrl = URL.createObjectURL(csvBlob);
		const link = document.createElement('a');
		link.href = downloadUrl;
		link.download = 'rainbird-rule-stats.csv';
		document.body.appendChild(link);
		link.click();
		document.removeChild(link);
	}

	componentDidMount () {
		this.updateMaxHeight();
	}

	componentDidUpdate () {
		this.updateMaxHeight();
	}

	render () {
		return (<div ref={ref => this.tableRef = ref} style={{ minHeight: this.state.maxHeight }}>
			<h2>
				Rule Stats
				<DownloadButton disabled={!this.props.stats.length} onClick={this.onDownloadClick} />
			</h2>
			<ReactTable
				data={this.props.stats}
				minRows={0}
				filterable
				className="-striped -highlight"
				onPageChange={this.updateMaxHeight}
				onPageSizeChange={this.updateMaxHeight}
				onFilteredChange={this.updateMaxHeight}
				columns={this.columns}
			/>
		</div>)
	}
}



// WEBPACK FOOTER //
// ./components/stats-table.js